import { CareGaps } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { CardComponent } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import careGaps from '../../../core-utils/messages/componentConstants';

export interface PatientDetailsCareGapsTabProps {
  careGapsData: any;
  isSelfImposed?: boolean;
}

const PatientDetailsCareGapsTab: React.FC<PatientDetailsCareGapsTabProps> = ({
  careGapsData,
  isSelfImposed,
}) => {
  const useStyles = makeStyles()({
    infoContainer: {
      display: 'flex',
      flexDirection: 'column',
      paddingLeft: '0.5rem',
      borderLeft: '5px solid',
    },
    infoText: {
      fontSize: '13px',
      fontWeight: 600,
    },
  });
  const { classes } = useStyles();

  const messages = careGaps.MOLECULES.PATIENT_DETAILS_CARE_GAPS_TAB;

  return (
    <>
      <Box
        style={{ position: 'relative', width: '900px', marginBottom: '28px' }}
      >
        <CardComponent
          title={isSelfImposed ? messages.TITLE2 : messages.TITLE1}
          subTitle={isSelfImposed ? messages.SUBTITLE2 : messages.SUBTITLE1}
          width="900px"
          body={<CareGaps careGapsData={careGapsData?.subCareGroup} />}
        />
        <Box
          style={{
            position: 'absolute',
            top: '20px',
            right: '28px',
            display: 'flex',
            gap: '2.5rem',
          }}
        >
          <Box
            className={classes.infoContainer}
            style={{
              borderColor: patientAccessTheme.palette.AIQChips?.background2,
            }}
          >
            <Typography className={classes.infoText}>
              {messages.COMPLIED}
            </Typography>
            <Typography align="center">
              {careGapsData?.compliedCount}
            </Typography>
          </Box>
          <Box
            className={classes.infoContainer}
            style={{
              borderColor: patientAccessTheme.palette.AIQChips?.background1,
            }}
          >
            <Typography className={classes.infoText}>
              {messages.NOTCOMPLIED}
            </Typography>
            <Typography align="center">
              {careGapsData?.notCompliedCount}
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default PatientDetailsCareGapsTab;
